import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'

import { StyledColumnHeader } from '../RatesAndFees.styled'

interface ColumnHeaderProps {
    heading: string
    icon?: React.ReactNode
}

const ColumnHeader = ({ heading, icon }: ColumnHeaderProps) => {
    return (
        <StyledColumnHeader>
            <Heading as="h3" variant="20">
                {heading}
            </Heading>
            {icon ? (
                <Box ml="space10" display="flex" justifyItems="center">
                    {icon}
                </Box>
            ) : null}
        </StyledColumnHeader>
    )
}

export default ColumnHeader
